// import React from 'react'
// import {Outlet} from 'react-router-dom'
// import SideBarFaq from './SideBarFaq'
// function Layout() {
//   return (
//     <div>
//       <SideBarFaq/>
//       <Outlet/>

//     </div>
//   )
// }

// export default Layout


// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import SideBarFaq from './SideBarFaq';

// function Layout() {
//   return (
//     <div className="flex h-screen">
//       {/* Sidebar */}
//       <div className="w-1/4 bg-gray-100">
//         <SideBarFaq />
//       </div>

//       {/* Main Content */}
//       <div className="w-3/4 p-4">
//         <Outlet />
//       </div>
//     </div>
//   );
// }

// export default Layout;

import React from 'react';
import { Outlet } from 'react-router-dom';
import SideBarFaq from './SideBarFaq';

function Layout() {
  return (
    <div className="flex h-screen p-8">
      {/* Fixed Sidebar */}
      <div className="w-1/3 ">
        <SideBarFaq />
      </div>

      {/* Dynamic Content */}
      <div className="w-4/6  overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
